import React from 'react';

/**
 * Represents a loading icon
 */

export function LoadingImg() {
    return <img src="icons/loading.gif" alt="Laden" />;
}
